var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-4 left" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("sidebar.paymententry")) +
                    "\n          "
                ),
                _vm.ready
                  ? [
                      _vm._v(
                        "\n            >\n            " +
                          _vm._s(_vm.payment.pe_code) +
                          "\n          "
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 right" }, [
            _vm.ready
              ? _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _vm.showOptionButton
                      ? _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn no-bg dropdown-toggle text-secondary shake",
                              attrs: {
                                id: "dropdownMenuButton",
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-cog" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(_vm.$t("button.options")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                              attrs: { "aria-labelledby": "dropdownMenuButton" }
                            },
                            [
                              _vm.hasRoleDelete
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          return _vm.openConfirmdeleteModal()
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-trash text-danger"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("button.delete"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown item" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn no-bg dropdown-toggle text-secondary",
                          attrs: {
                            id: "dropdownMenuButton",
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-download" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.$t("button.download")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu dropdown-menu-right",
                          attrs: { "aria-labelledby": "dropdownMenuButton" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  return _vm.downloadPdf()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-secondary" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.filename", {
                                      string: "PDF"
                                    })
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown nodro item" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn no-bg text-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.openPrintModal()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-print" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.$t("button.print")))
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    [
                      _vm.payment.status == "padding" && _vm.hasRoleEdit
                        ? _c("div", { staticClass: "dropdown item" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn no-bg dropdown-toggle text-info",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [
                                _c("i", { staticClass: "far fa-circle" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(_vm._s(_vm.$t("status.pe.unpaid")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu dropdown-menu-right"
                              },
                              [
                                _vm.payment.status == "padding"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function($event) {
                                            return _vm.updatePaymentStatus({
                                              pe_id: _vm.payment.pe_id,
                                              status: "paid"
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "far fa-check-circle text-success",
                                          staticStyle: {
                                            position: "relative",
                                            left: "-7px"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("status.pe.paid"))
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        : _c(
                            "div",
                            { staticClass: "dropdown nodro item" },
                            [
                              [
                                _vm.getPaymentStatus(_vm.payment, _vm.$t)
                                  .status == "padding"
                                  ? _c("span", { staticClass: "text-info" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getPaymentStatus(
                                              _vm.payment,
                                              _vm.$t
                                            ).message
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.getPaymentStatus(_vm.payment, _vm.$t)
                                  .status == "completed"
                                  ? _c(
                                      "span",
                                      { staticClass: "text-success" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getPaymentStatus(
                                                _vm.payment,
                                                _vm.$t
                                              ).message
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm.getPaymentStatus(_vm.payment, _vm.$t)
                                      .status == "uncompleted"
                                  ? _c("span", { staticClass: "text-info" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getPaymentStatus(
                                              _vm.payment,
                                              _vm.$t
                                            ).message
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            ],
                            2
                          )
                    ]
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("WrapperDoc", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "form",
                        fn: function() {
                          return [
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t(
                                        "message.typeofpaymententry"
                                      ),
                                      subtitle:
                                        _vm.$t("series.pe") +
                                        " " +
                                        _vm.payment.pe_code
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row mt-3" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 row no-margin no-padding"
                                        },
                                        [
                                          _c(
                                            "vs-radio",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                padding: "0"
                                              },
                                              attrs: {
                                                disabled: true,
                                                color: "#A3CA76",
                                                vsValue: "pay"
                                              },
                                              model: {
                                                value: _vm.formType,
                                                callback: function($$v) {
                                                  _vm.formType = $$v
                                                },
                                                expression: "formType"
                                              }
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.checkboxexpense"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-check-label",
                                          staticStyle: { "margin-left": "25px" }
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.checkboxexpensedetails"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 row no-margin no-padding"
                                        },
                                        [
                                          _c(
                                            "vs-radio",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                padding: "0"
                                              },
                                              attrs: {
                                                disabled: true,
                                                color: "#A3CA76",
                                                vsValue: "receive"
                                              },
                                              model: {
                                                value: _vm.formType,
                                                callback: function($$v) {
                                                  _vm.formType = $$v
                                                },
                                                expression: "formType"
                                              }
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.checkboxreceive"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-check-label",
                                          staticStyle: { "margin-left": "25px" }
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.checkboxreceivedetails"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", { staticClass: "mb-3" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.reference")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-4" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("message.type")))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          staticClass:
                                            "form-control custom-select",
                                          class: [_vm.bindClass.doc_type],
                                          attrs: { disabled: true }
                                        },
                                        [
                                          _vm.getDocInfo(_vm.payment).type ==
                                          "po"
                                            ? _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "po",
                                                    selected: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("documents.po")
                                                    ) +
                                                      " / PO-\n                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.getDocInfo(_vm.payment).type ==
                                          "ex"
                                            ? _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "ex",
                                                    selected: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("documents.ex")
                                                    ) +
                                                      " / EX-\n                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.getDocInfo(_vm.payment).type ==
                                          "in"
                                            ? _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "in",
                                                    selected: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("documents.in")
                                                    ) +
                                                      " / INV-\n                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.getDocInfo(_vm.payment).type ==
                                          "prl"
                                            ? _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "in",
                                                    selected: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("documents.prl")
                                                    ) +
                                                      " / PRL-\n                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.form.doc_type != ""
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col-8",
                                            staticStyle: {
                                              position: "relative"
                                            }
                                          },
                                          [
                                            _vm.loadingPO ||
                                            _vm.loadingIN ||
                                            _vm.loadingEX ||
                                            _vm.loadingPRL
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-spinner spin",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    top: "34px",
                                                    right: "36px"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.series")
                                                  )
                                                )
                                              ])
                                            ],
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                staticClass:
                                                  "form-control custom-select",
                                                class: [
                                                  _vm.bindClass.doc_series
                                                ],
                                                attrs: { disabled: true }
                                              },
                                              [
                                                _c("option", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getDocInfo(
                                                        _vm.payment
                                                      ).code
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.form.doc_type != "" && _vm.form.doc_series != ""
                              ? _c("section", { staticClass: "mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 no-padding" },
                                    [
                                      _c("section-header", {
                                        attrs: {
                                          title: _vm.sectionHeaderRefCode
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-row mt-2" },
                                        [
                                          [
                                            _vm.partnerInfo.vendor !== undefined
                                              ? _c(
                                                  "div",
                                                  { staticClass: "col-4" },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.vendor"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.partnerInfo
                                                          .vendor
                                                          ? _vm.partnerInfo
                                                              .vendor
                                                              .vendor_name
                                                          : ""
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.partnerInfo.customer !==
                                            undefined
                                              ? _c(
                                                  "div",
                                                  { staticClass: "col-4" },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.customer"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.partnerInfo
                                                          .customer
                                                          ? _vm.partnerInfo
                                                              .customer
                                                              .customer_name
                                                          : ""
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-4" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.debttotal")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              [
                                                _vm.docInfo.po
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control text-info",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getDebtPurchaseAmount(
                                                            _vm.docInfo.po
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.in
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control text-info",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getDebtInvoiceAmount(
                                                            _vm.docInfo.in
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.ex
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control text-info",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getDebtExpenseAmount(
                                                            _vm.docInfo.ex
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.prl
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control text-info",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getDebtPayslipAmount(
                                                            _vm.docInfo.prl
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "col-md-2":
                                                  !_vm.docInfo.ex ||
                                                  !_vm.docInfo.prl,
                                                "col-md-4":
                                                  _vm.docInfo.ex ||
                                                  _vm.docInfo.prl
                                              }
                                            },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.paidtotal")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              [
                                                _vm.docInfo.po
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getPaidAmount(
                                                            _vm.docInfo.po
                                                              .reference
                                                              .payments
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.in
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getPaidAmount(
                                                            _vm.docInfo.in
                                                              .reference
                                                              .payments
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.ex
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getPaidAmount(
                                                            _vm.docInfo.ex
                                                              .reference
                                                              .payments
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.prl
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.docInfo.prl.net -
                                                            _vm.docInfo.prl
                                                              .process.debit
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "col-md-2":
                                                  !_vm.docInfo.ex ||
                                                  !_vm.docInfo.prl,
                                                "col-md-4":
                                                  _vm.docInfo.ex ||
                                                  _vm.docInfo.prl
                                              }
                                            },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.grandtotal")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              [
                                                _vm.docInfo.po
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getTotal(
                                                            _vm.docInfo.po
                                                              .orders
                                                          ).payment
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.in
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.getTotal(
                                                            _vm.docInfo.in
                                                              .orders
                                                          ).payment
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.ex
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.docInfo.ex.payment
                                                            .amount
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.docInfo.prl
                                                  ? _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled: true,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value: _vm.setToCustomDigitsNumber(
                                                          _vm.docInfo.prl.net
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            ],
                                            2
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.infopayment")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row mb-2" }, [
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("message.type")))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.payment_type,
                                              expression: "form.payment_type"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          attrs: { disabled: _vm.disabledForm },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.form,
                                                "payment_type",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "cash" } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.cash"))
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "card" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.creditcard")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("message.paidamount", {
                                              string: _vm.currency
                                            })
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.payment_amount,
                                            expression: "form.payment_amount"
                                          }
                                        ],
                                        staticClass:
                                          "form-control number-only text-select-all",
                                        class: [_vm.bindClass.payment_amount],
                                        attrs: {
                                          disabled: _vm.disabledForm,
                                          type: "text"
                                        },
                                        domProps: {
                                          value: _vm.form.payment_amount
                                        },
                                        on: {
                                          keypress: _vm.numberOnly,
                                          keyup: function($event) {
                                            _vm.form.payment_amount = _vm.setToValidNumber(
                                              _vm.form.payment_amount
                                            )
                                          },
                                          blur: function($event) {
                                            _vm.form.payment_amount = _vm.setToCustomDigitsNumber(
                                              _vm.form.payment_amount
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "payment_amount",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.postingpaiddate")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("BaseInputDatePicker", {
                                          attrs: { disabled: _vm.disabledForm },
                                          model: {
                                            value: _vm.form.payment_date,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "payment_date",
                                                $$v
                                              )
                                            },
                                            expression: "form.payment_date"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row mb-3" }, [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("message.note")))
                                      ]),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.note,
                                            expression: "form.note"
                                          }
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        staticStyle: { "min-height": "90px" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "placeholder.dotted"
                                          ),
                                          disabled: _vm.disabledForm
                                        },
                                        domProps: { value: _vm.form.note },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "note",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.disabledForm
                              ? _c(
                                  "section",
                                  { staticClass: "action-bar" },
                                  [
                                    [
                                      !_vm.$store.state.app.loading
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 text-right"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-web",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.update()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.save")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 text-right"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-web btn-block-mobile-only",
                                                  attrs: { disabled: "" }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-spinner spin"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                    ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "ref",
                        fn: function() {
                          return [
                            _c("DocRef", {
                              attrs: {
                                refDoc: "pe",
                                refId: _vm.payment.pe_id,
                                refCode: _vm.payment.pe_code,
                                showLog:
                                  _vm.getAccountSetting.log_topic.is_active,
                                showAttachFile:
                                  _vm.getAccountSetting.attach_file.is_active,
                                logTopics:
                                  _vm.getAccountSetting.log_topic.options,
                                isSubmitted: _vm.isSubmitted
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    4055491468
                  )
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "printModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-print-a4",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-body p-0",
                    staticStyle: {
                      background: "#C9CCCE",
                      height: "660px",
                      overflow: "auto"
                    }
                  },
                  [
                    _vm.ready
                      ? _c("printpe-view", {
                          staticClass: "print-template",
                          attrs: {
                            data: _vm.docInfo,
                            payment: _vm.payment,
                            form: _vm.form
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-web",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.onclickPrint()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.print")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closePrintModal()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.close")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "confirmdeleteModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog ", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    staticStyle: { "border-bottom": "none" }
                  },
                  [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.areyousuretodeletethis")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.$store.state.app.loading
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: {
                              click: function($event) {
                                return _vm.closeConfirmdeleteModal()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeConfirmdeleteModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.del()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.delete")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", disabled: "" }
      },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af6c9cbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af6c9cbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/accounts/paymententry/Edit.vue
// module id = null
// module chunks = 